
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5Xvyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ddfc618b21c3a3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $31ddfc618b21c3a3$var$RedactionOnboardingAndFlag = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("guRYZ")).then((module)=>module.default), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-redaction/onboarding/src/ui/index.tsx"
});
const $31ddfc618b21c3a3$var$AsyncRedactionOnboardingAndFlag = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "redaction-onboarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31ddfc618b21c3a3$var$RedactionOnboardingAndFlag, props));
var $31ddfc618b21c3a3$export$2e2bcd8739ae039 = $31ddfc618b21c3a3$var$AsyncRedactionOnboardingAndFlag;

});
parcelRegister("guRYZ", function(module, exports) {

let $c0295287b67d69aa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c0295287b67d69aa$var$load("czPin").then(()=>parcelRequire('L8a1G'));

});



//# sourceMappingURL=async.45176942.js.map
